import {HTTP} from '../http-common';
import {UTILS} from '../http-common';
import discovery from '../discovery';
import gwt from './gwt';

export default {
    getCommonHeaders()
    {
        var headers = {};

        headers = {
            'authorization': 'Bearer ' + window.kc_token
        };

        let kioskEmployeeId = window.localStorage.getItem('worktime.kiosk.employee.id');
		if (kioskEmployeeId) {
            headers["X-KIOSK-EMPLOYEE"] = kioskEmployeeId;
            headers["X-DEVICE-TYPE"] = 'KIOSKO';
        } else {
            headers["X-DEVICE-TYPE"] = gwt.isApp() ? 'APP' : 'WEB';
        }
 
        ///////////////////////////////////////////////////////////////
        // FIX multiples perfiles

        let clientCompany = window.localStorage.getItem('worktime.client.company.id');
        if (clientCompany) {
            headers['x-client-company'] = clientCompany;
        }

        ///////////////////////////////////////////////////////////////

        if (/MSIE|Trident/.test(window.navigator.userAgent))
        {
            headers['Pragma'] = 'no-cache';
            headers['Cache-Control'] = 'no-cache, no-store';
        }

        return { headers: headers };
    },
    genericGet(service,cbok, cberr)
    {
        HTTP
            .get(discovery.worktime_service_url+service,
            this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericPut (service,data,cbok, cberr)
    {
        HTTP
            .put(discovery.worktime_service_url+service,
            data,this.getCommonHeaders())
            .then((response) => {
                if (cbok)
                    cbok(response.data);
            }).catch(function (error) {
                if (cberr)
                    cberr(error);
            });
    },
    genericPost(service,data,cbok, cberr)
    {
        HTTP
            .post(discovery.worktime_service_url+service,
            data,this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericDelete(service,cbok, cberr)
    {
        HTTP
            .delete(discovery.worktime_service_url+service,
            this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    getContextValue(key)
    {
        return window.tweemContext ? window.tweemContext[key]:'';
    },
    /////////////////////////////////////////////////////////////////
    //COMMON 
    
		getStaff (cbok, cberr)
    {
        this.genericGet('admin/staff', cbok, cberr);
    },
    executeQuery (data, cbok, cberr)
    {
        this.genericPost('analytics/executeQuery', data, cbok, cberr);
    },
		getCompanies (cbok, cberr)
    {
        this.genericGet('admin/companies', cbok, cberr);
    },
    getWorkplacesByCompanyId(companyId, cbok, cberr)
		{
        this.genericGet('admin/workplaces-by-company-id/'+ companyId, cbok, cberr);
    },

     /////////////////////////////////////////////////////////////////
    /*/Dialog manager
    getDialog (id, cbok, cberr)
    {
        this.genericGet('dialog/'+id, cbok, cberr);
    },    
    deleteDialog (id, cbok, cberr)
    {
        this.genericDelete('dialog/'+id, cbok, cberr);
    },   
    storeDialog(module, cbok, cberr)
    {
        this.genericPost('dialog/', module, cbok, cberr);
    },    
    getDialogs (cbok, cberr)
    {
        this.genericGet('dialog/config', cbok, cberr);
    }, */

    /////////////////////////////////////////////////////////////////
    //Module manager
    /*getModule (id, cbok, cberr)
    {
        this.genericGet('module/'+id, cbok, cberr);
    },    
    deleteModule (id, cbok, cberr)
    {
        this.genericDelete('module/'+id, cbok, cberr);
    },   
    storeModule (module, cbok, cberr)
    {
        this.genericPost('module/', module, cbok, cberr);
    },    
    getModules (cbok, cberr)
    {
        this.genericGet('module/config', cbok, cberr);
    }, 
    getModuleData (id, context, cbok, cberr)
    {
        this.genericPost('module/data/' + id, context, cbok, cberr);
    }, */
    /////////////////////////////////////////////////////////////////
    //Export module
    downloadExportCSV(id, cbok, cberr)
    {
        let options = this.getCommonHeaders();
        options.responseType= 'blob';
        HTTP
            .get(discovery.worktime_service_url + 'admin/download-export-csv/' + id, options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }
                
                UTILS.downloadDocument(response);

            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
              });
    },
    getLinkDownloadExportCSV(id, cbok, cberr)
    {   
        HTTP
            .get(discovery.worktime_service_url + 'admin/export-csv-link/' + id, this.getCommonHeaders())
            .then((response) => {
                if (cbok) {
                    let url = discovery.worktime_service_url;
                    url = url.replace('/rest/', '');
                    url = `${url}/${response.data}`;
                    cbok(url);
                }
            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
              });
    },    
    deleteExport (id, cbok, cberr)
    {
        this.genericDelete('admin/delete-export/' + id, cbok, cberr);
    },
   /////////////////////////////////////////////////////////////////
    //AUDITLOG
    
    getAuditLog (id, cbok, cberr)
    {
        this.genericGet('admin/audit-log/'+id, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //EXPENSE SHEETS

    getExpenseSheets (companyId, sortBy, sortDesc, cbok, cberr)
    {
        this.genericGet(`user/expense-sheet/${companyId}/list?sortBy=${sortBy}&sortDesc=${sortDesc}`, cbok, cberr);
    },
    getFullExpenseSheetById (id, cbok, cberr)
    {
        this.genericGet(`user/full-expense-sheet/${id}`, cbok, cberr);
    },
    getExpenseSheetById (id, cbok, cberr)
    {
        this.genericGet(`user/expense-sheet/${id}`, cbok, cberr);
    },
    extractExpenseSheetItemTicketInfo (data, cbok, cberr)
    {
        this.genericPost(`user/expense-sheet-item/ticket-info`, data, cbok, cberr);
    },
    deleteExpenseSheetItemDocument(id, cbok, cberr)
    {
        this.genericPost(`user/expense-sheet-item/${id}/delete-document`, null, cbok, cberr);
    },
    storeExpenseSheet (data, cbok, cberr)
    {
        this.genericPost(`user/expense-sheet`, data, cbok, cberr);
    },
    sendExpenseSheetById (id, cbok, cberr)
    {
        this.genericPost(`user/expense-sheet/${id}/send`, null, cbok, cberr);
    },
    cancelExpenseSheetRequestById (id, cbok, cberr)
    {
        this.genericPost(`user/expense-sheet/${id}/cancel-request`, null, cbok, cberr);
    },
    deleteExpenseSheetById (id, cbok, cberr)
    {
        this.genericDelete(`user/expense-sheet/${id}`, cbok, cberr);
    },
    getExpenseSheetItemsBySheetId (sheetId, sortBy, sortDesc, cbok, cberr)
    {
        this.genericGet(`user/expense-sheet-item/${sheetId}/list?sortBy=${sortBy}&sortDesc=${sortDesc}`, cbok, cberr);
    },
    downloadExpenseSheetItemDocumentContent (sheetId, sheetItemId, cbok, cberr)
    {
        let options = this.getCommonHeaders();
        options.responseType= 'blob';
        HTTP
            .get(`${discovery.worktime_service_url}user/expense-sheet-item/${sheetId}/download/${sheetItemId}`, options)
            .then(async (response) => {
                if (cbok) {
                    const blob = response.data;
                    const buffer = Buffer.from(await blob.arrayBuffer());
                    const base64 = "data:" + blob.type + ';base64,' + buffer.toString('base64');
                    cbok(base64);
                }
            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    downloadExpenseSheetItemDocument (sheetId, sheetItemId, cbok, cberr)
    {
        let options = this.getCommonHeaders();
        options.responseType= 'blob';
        HTTP
            .get(`${discovery.worktime_service_url}user/expense-sheet-item/${sheetId}/download/${sheetItemId}`, options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }
                
                UTILS.downloadDocument(response);

            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    getExpenseSheetCategories (cbok, cberr)
    {
        this.genericGet(`user/expense-sheet-category`, cbok, cberr);
    },
    getExpenseSheetItemById (id, cbok, cberr)
    {
        this.genericGet(`user/expense-sheet-item/${id}`, cbok, cberr);
    },
    storeExpenseSheetItem (data, cbok, cberr) {
        this.genericPost('user/expense-sheet-item', data, cbok, cberr);
    },
    deleteExpenseSheetItemById (id, cbok, cberr)
    {
        this.genericDelete(`user/expense-sheet-item/${id}`, cbok, cberr);
    },

}

